import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '@ublend-npm/aulaui-next-web/themes/default';

import createSvgIcon from './hoc/createSvgIcon';

const LogoSymbolSvg = React.memo(({ fill }) => {
  return (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.92857 0C13.8597 0 17.8571 3.99746 17.8571 8.92857V17.5893H0V8.92857C0 3.99746 3.99746 0 8.92857 0ZM71.0714 0C76.0025 0 80 3.99746 80 8.92857V17.5893H62.1429V8.92857C62.1429 3.99746 66.1403 0 71.0714 0ZM20.5357 8.92854V0.267859L38.3929 0.267858V8.92854V8.92857C38.3929 13.8597 34.3954 17.8571 29.4643 17.8571C24.5332 17.8571 20.5357 13.8597 20.5357 8.92857V8.92854ZM59.1964 17.5893L41.3393 17.5893V9.01786L41.3393 0.267857L50.5357 0.267857V9.01786L59.1964 9.01785V17.5893Z"
      fill={fill}
    />
  );
});

LogoSymbolSvg.propTypes = {
  fill: PropTypes.string,
};
LogoSymbolSvg.defaultProps = {
  fill: colors.white,
};

export default createSvgIcon({
  svg: LogoSymbolSvg,
  displayName: 'Logo',
  viewBox: '0 0 80 18',
});
